import { Actions } from '../../../../utils/Action'
import { ActionTypes } from './types'
import { TDefRequest } from '../../../../types/actions'

/// ///////////////////////////////////////////////////////////////////////
const GetGeneralActivityActions = new Actions('GET_GENERAL_ACTIVITY', ActionTypes)
const GetGeneralActivityWith0OffsetActions = new Actions('GET_GENERAL_ACTIVITY_WITH_O_OFFSET', ActionTypes)

export interface TypeGetGeneralActivityR extends TDefRequest {
  idTender: number
  offset?: number
  limit?: number
  search?: string
  sortBy?: string
  sort?: string
}

export const GetGeneralActivity = {
  request: (payload: TypeGetGeneralActivityR) => GetGeneralActivityActions.request(payload),
  success: (payload: any) => GetGeneralActivityActions.success(payload),
  error: (payload: string) => GetGeneralActivityActions.error(payload),
}
export const GetGeneralActivityWith0Offset = {
  success: (payload: any) => GetGeneralActivityWith0OffsetActions.success(payload),
}
